// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__2n876","Quote":"Hero_Quote__37XVu","cta":"Hero_cta__2GhdH","ctaContainer":"Hero_ctaContainer__3HlCL","ctaQuote":"Hero_ctaQuote__1uKYO","BG":"Hero_BG__2UZFq"};